import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center min-h-[200px] p-6" }
const _hoisted_2 = { class: "text-center text-gray-600 text-base mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center gap-4"
}
const _hoisted_4 = { class: "text-sm text-gray-500 uppercase tracking-widest" }
const _hoisted_5 = { class: "flex flex-wrap justify-center gap-3" }
const _hoisted_6 = ["onClick"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Suggestion {
  label: string;
  action: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogResultEmpty',
  props: {
    activeFilters: {}
  },
  emits: ["update:filter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const suggestions = computed<Suggestion[]>(() => {
  const result: Suggestion[] = [];

  // 1. Suggest increasing price if price filter is active
  if (props.activeFilters.price) {
    const [min, max] = props.activeFilters.price.split('-').map(Number);
    if (!isNaN(max)) {
      const newMax = Math.round(max * 2 / 100) * 100;
      result.push({
        label: t('components.catalog.suggestion.increase_max_price', { price: newMax }),
        action: () => {
          emit('update:filter', 'price', `${min}-${newMax}`);
        }
      });
    }
  }

  // 2. Suggest changing stone form to round if it's something else
  if (props.activeFilters.stone_form && props.activeFilters.stone_form !== 'round') {
    result.push({
      label: t('components.catalog.suggestion.try_round_stone_form'),
      action: () => emit('update:filter', 'stone_form', 'round')
    });
  }

  // 3. Suggest clearing a specific filter (e.g., the last one or just any)
  const filtersToClear = Object.keys(props.activeFilters).filter(f => f !== 'stone_type');
  if (filtersToClear.length > 0) {
    const filterToClear = filtersToClear[filtersToClear.length - 1];
    result.push({
      label: t('components.catalog.suggestion.remove_filter', { filter: t(`components.catalog.filter.${filterToClear}.label`) }),
      action: () => emit('update:filter', filterToClear, '')
    });
  }

  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('components.catalog.no_products_found')), 1),
    (suggestions.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('components.catalog.suggestions_title')), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                onClick: suggestion.action,
                class: "px-4 py-2 bg-white border border-brand-main text-brand-text hover:bg-brand-main hover:text-white text-sm transition-colors rounded-sm uppercase tracking-wider"
              }, _toDisplayString(suggestion.label), 9, _hoisted_6))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})